module.exports = __webpack_public_path__ + "img/redgantanhao.d3eedd42.svg";